import { render, staticRenderFns } from "./Legenda.vue?vue&type=template&id=3d0d25c4&scoped=true&"
import script from "./Legenda.vue?vue&type=script&lang=js&"
export * from "./Legenda.vue?vue&type=script&lang=js&"
import style0 from "./Legenda.vue?vue&type=style&index=0&id=3d0d25c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0d25c4",
  null
  
)

export default component.exports